import { render, staticRenderFns } from "./GoBtn.vue?vue&type=template&id=e1429696&"
import script from "./GoBtn.vue?vue&type=script&lang=js&"
export * from "./GoBtn.vue?vue&type=script&lang=js&"
import style0 from "./GoBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports